/* Wonder / Recharge purchase-plan guard.
 * Recharge owns the initial purchase choice, price and delivery interval.
 * At submission, copy only the visible selection belonging to this product form.
 * Missing or inconsistent purchase options stop submission; they never silently
 * turn a subscription into a differently priced one-time purchase.
 */
(function () {
  'use strict';

  var WIDGET = '.rc-widget, .rc_widget';

  function value(form, name) {
    var input = form && form.querySelector('[name="' + name + '"]');
    return input ? input.value : '';
  }

  function visible(element) {
    if (!element || !element.isConnected || !element.getClientRects().length) return false;
    for (var node = element; node && node.nodeType === 1; node = node.parentElement) {
      var style = window.getComputedStyle(node);
      if (node.hidden || node.inert || node.getAttribute('aria-hidden') === 'true' ||
          style.display === 'none' || style.visibility !== 'visible' || style.opacity === '0') return false;
    }
    return true;
  }

  function selected(radio) {
    if (!radio || !radio.checked || radio.disabled || !visible(radio)) return false;
    for (var i = 0; i < radio.labels.length; i++) if (visible(radio.labels[i])) return true;
    return false;
  }

  function widgetFor(form) {
    var scope = form.closest('.shopify-section') || form;
    var widgets = scope.querySelectorAll(WIDGET);
    var matches = [];
    for (var i = 0; i < widgets.length; i++) {
      var owner = widgets[i].closest('form');
      if (owner === form || ['product-id', 'section-id', 'id'].every(function (name) {
        return value(form, name) !== '' && value(form, name) === value(owner, name);
      })) matches.push(widgets[i]);
    }
    return matches.length === 1 ? matches[0] : null;
  }

  function stopSubmission(event, form, inputs) {
    for (var i = 0; i < inputs.length; i++) inputs[i].value = '';
    event.preventDefault();
    event.stopImmediatePropagation();
    var message = 'Purchase options could not be confirmed. Please refresh the page and try again.';
    var productForm = form.closest('product-form');
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage(message);
      return;
    }
    var error = form.querySelector('[data-purchase-plan-error]');
    if (!error) {
      error = document.createElement('p');
      error.setAttribute('data-purchase-plan-error', '');
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.textContent = message;
  }

  // Capture runs before Wonder serializes the form into its cart request.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !/\/cart\/add(?:\.js)?$/.test(action.pathname)) return;

    var inputs = Array.prototype.filter.call(form.querySelectorAll('input[name="selling_plan"]'), function (input) {
      return !input.closest(WIDGET);
    });
    if (!inputs.length) return;

    var widget = widgetFor(form);
    if (!visible(widget)) return stopSubmission(event, form, inputs);
    var oneTime = widget.querySelector('input.rc_widget__option__input--onetime');
    var subscription = widget.querySelector('input.rc_widget__option__input--subsave');
    var plan = '';
    if (selected(oneTime) && !(subscription && subscription.checked)) {
      plan = '';
    } else if (selected(subscription) && !(oneTime && oneTime.checked)) {
      var dropdown = widget.querySelector('select[name="selling_plan"]');
      if (!visible(dropdown) || dropdown.disabled || !/^\d+$/.test(dropdown.value) ||
          !dropdown.selectedOptions.length || dropdown.selectedOptions[0].disabled ||
          !inputs.some(function (input) { return !input.disabled; })) return stopSubmission(event, form, inputs);
      plan = dropdown.value;
    } else {
      return stopSubmission(event, form, inputs);
    }
    for (var i = 0; i < inputs.length; i++) inputs[i].value = plan;
    var error = form.querySelector('[data-purchase-plan-error]');
    if (error) error.remove();
  }, true);
})();
